import React, { useEffect, useState } from "react";
import classes from "./PartnershipProgramCard.module.css";
import Fonts from "../assets/Fonts";
import Colors from "../assets/Colors";
import { AthleteImg } from "../../constant/imagePath";
import PropTypes from "prop-types";
import { ReactSVG } from "react-svg";

export const PartnershipProgramCard = ({
  image,
  heading,
  description,
  onClick,
  isActive,
}) => {
  const headings = heading.split(" ");
  return (
    <div
      className={classes.card}
      style={{ borderBottomColor: Colors.neutralShadesOfGainsboro }}
    >
      <div className={classes.title} onClick={onClick}>
        {headings?.map((item) => {
          return (
            <h4
              style={{
                ...Fonts.h4,
                fontSize: "26px",
                color: isActive
                  ? Colors.mainShadeOfRed
                  : Colors.neutralShadesOfNero,
              }}
            >
              {item}
            </h4>
          );
        })}
      </div>
      <div className={classes.description}>
        <p style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}>
          {description}
        </p>
      </div>
      {isActive && image && (
        <div className={classes.imgBox}>
          <img src={image} />
        </div>
      )}
    </div>
  );
};

PartnershipProgramCard.propTypes = {
  image: PropTypes.string,
  heading: PropTypes.string,
  description: PropTypes.string,
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
};
PartnershipProgramCard.defaultProps = {
  image: AthleteImg,
  heading: "Club Partnerships",
  description:
    "All of our coaches have extensive coaching experience and are required to pass rigorous background checks.",
  isActive: false,
};
